import React from "react";
interface MetricsData {
  totalSuppliers: number;
  pendingApproval: number;
  activeSuppliers: number;
  suspendedSuppliers: number;
  totalRevenue: number;
}

interface MetricsProps {
  metrics: MetricsData;
  information: any;
}
const SingleMetricCard: React.FC<MetricsProps> = ({ metrics, information }) => {
  return (
    <div className="my-7">
      <div className="flex md:grid md:grid-cols-3 gap-4 overflow-x-auto scrollbar-hide lg:overflow-visible whitespace-nowrap">
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Available Quantity
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {information?.quantity || 0} {information?.measurementUnit}
          </h1>
        </section>

        {/* Orders Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Reorder level
            <button type="button"></button>
          </p>
          <h1 className="text-[#F59E0B] text-[36px] font-extrabold">
            {information?.reorderLevel || 0} {information?.measurementUnit}
          </h1>
        </section>

        {/* Withdrawals Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Total Revenue Generated
            <button type="button"></button>
          </p>
          <h1 className="text-[#F43F5E] text-[36px] font-extrabold">
            {" "}
            #{(information?.totalRevenue || 0).toLocaleString('en-US')}
          </h1>
        </section>
        {/* Out Escrow Card */}
      </div>
    </div>
  );
};

export default SingleMetricCard;
